import { useState, useEffect } from 'react';
import { Route, Redirect } from 'react-router-dom';
import { useHistory } from "react-router";
import { useLazyQuery } from '@apollo/client';
import { GET_PROFILE } from '../gql/auth/queries';
import { useApolloClient } from '@apollo/client';
// import { Spinner } from 'react-bootstrap';
import Loader from '../components/loader/Loader';


const TwilioAuthRoute = ({ component: Component, ...rest }) => {

    const history = useHistory();
    const client = useApolloClient()
    const [textProviderActive, setTextProviderActive] = useState(null)
    const [errorMessage, setErrorMessage] = useState('')
    const [isActive, setIsActive] = useState(true)
    const [softDelete, setSoftDelete] = useState(false)

    const userToken = localStorage.getItem('token')
    const userRToken = localStorage.getItem('token')
    const userInfo = JSON.parse(localStorage.getItem('user'))
    const name = userInfo?.name


    const [loadUser, {loading}] = useLazyQuery(GET_PROFILE, {
        onCompleted(data) {
            setTextProviderActive(data?.me?.textProvider)
            setIsActive(data?.me?.isActive)
            setSoftDelete(data?.me?.softDelete)
        },
        fetchPolicy: "network-only",
        onError(error) {
          if (error) {
            if (error.networkError && typeof window !== 'undefined' && !window.navigator.onLine) {
              setErrorMessage("Check Your Network, Your Browser Is Offline")
            }
            if (error.message) {
              setErrorMessage(error.message)
            }
            if (!error.message) {
              setErrorMessage("Something Went Wrong !")
            }
          }
        }
    });

    useEffect(() => {
        loadUser()
        // eslint-disable-next-line
    }, [])


    if (!userToken || !userRToken || !name || errorMessage) {
      try {
        client.resetStore()
        client.cache.reset()
        localStorage.removeItem('token')
        localStorage.removeItem('refreshtoken')
        localStorage.removeItem('user')
        history.push('/')
      } 
      catch (error) {
        client.cache.reset() 
        localStorage.removeItem('token')
        localStorage.removeItem('refreshtoken')
        localStorage.removeItem('user')
        history.push('/')
        console.error(error)
      }
    }

    if(isActive === false){
      try {
        client.resetStore()
        client.cache.reset()
        localStorage.removeItem('token')
        localStorage.removeItem('refreshtoken')
        localStorage.removeItem('user')
        history.push('/')
      } 
      catch (error) {
        client.cache.reset() 
        localStorage.removeItem('token')
        localStorage.removeItem('refreshtoken')
        localStorage.removeItem('user')
        history.push('/')
        console.error(error)
      }
    }
  
    if(softDelete === true){
      try {
        client.resetStore()
        client.cache.reset()
        localStorage.removeItem('token')
        localStorage.removeItem('refreshtoken')
        localStorage.removeItem('user')
        history.push('/')
      } 
      catch (error) {
        client.cache.reset() 
        localStorage.removeItem('token')
        localStorage.removeItem('refreshtoken')
        localStorage.removeItem('user')
        history.push('/')
        console.error(error)
      }
    }

    if (loading) {
      return <Loader />
  }

    return (
        <>
            {/* <Route {...rest} render={ (props) => emailProviderActive === null ? (<Component {...props} />) : emailProviderActive === "gmail" ?  (<Redirect to='/settings/email-provider/google-email' />) : emailProviderActive === "smtp" ? (<Redirect to='/settings/email-provider/smtp' />) : (<Redirect to='/' />) } /> */}
            <Route {...rest} render={ (props) => textProviderActive === null ? (<Component {...props} />) : textProviderActive === "twilio" ?  (<Redirect to='/settings/text-provider/twilio' />) : (<Redirect to='/' />) } />
        </>
    )
}

export default TwilioAuthRoute;
